export const FETCH_INSTRUCTOR_INITIAL = "FETCH_INSTRUCTOR_INITIAL";
export const FETCH_INSTRUCTOR_SUCCESS = "FETCH_INSTRUCTOR_SUCCESS";
export const FETCH_INSTRUCTOR_FAILURE = "FETCH_INSTRUCTOR_FAILURE";
